const VacationErrorCodes = {
  VAC00001: 'O colaborador está afastado(a)',
  VAC00002: 'O colaborador está desligado(a)',
} as const;

export default VacationErrorCodes;
